<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Gy2l1y/tc-custom/9781250144034.jpg?1731010946453" alt="This image is the cover for the book Watch Me"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Watch Me
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"Riveting, chilling, and page-turning.  Be prepared to stay up all night." -- <i>New York Times</i> bestselling author Lisa Scottoline</b><br/><br/>For fans of dark and twisty psychological thrillers, <i>Watch Me</i> is a riveting novel of suspense about how far obsession can go.<br/><br/>Kate Youngblood is disappearing. Muddling through her late 30s as a creative writing professor at Blackwood college, she’s dangerously close to never being noticed again. The follow-up novel to her successful debut tanked. Her husband left her for a woman ten years younger. She’s always been bright, beautiful, independent and a little wild, but now her glow is starting to vanish. She’s heading into an age where her eyes are less blue, her charm worn out, and soon no one will ever truly look at her, want to know her, again. <br/><br/>Except one.<br/><br/>Sam Grist is Kate’s most promising student. An unflinching writer with razor-sharp clarity who gravitates towards dark themes and twisted plots, his raw talent is something Kate wants to nurture into literary success. But he’s not there solely to be the best writer. He’s been watching her. Wanting her. Working his way to her for years. <br/><br/>As Sam slowly makes his way into Kate’s life, they enter a deadly web of dangerous lies and forbidden desire. But how far will his fixation go? And how far will she allow it?<br/><br/>A gripping novel exploring intense obsession and illicit attraction, Jody Gehrman introduces a world where what you desire most may be the most dangerous thing of all.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jody Gehrman
      </h2>
      
      <p class="authorDescription body article">Jody Gehrman has authored several novels and numerous plays for stage and screen. Her young-adult novel, <I>Babe in Boyland, </I>won the International Reading Association’s Teen Choice Award and was optioned by the Disney Channel. Jody’s plays have been produced or had staged readings in Ashland, New York, San Francisco, Chicago and L.A. Her full-length, <I>Tribal Life in America, </I>won the Ebell Playwrights Prize and received a staged reading at the historic Ebell Theater in Los Angeles. She and her partner David Wolf won the New Generation Playwrights Award for their one-act, <I>Jake Savage, Jungle P.I.</I> She holds a Masters Degree in Professional Writing from the University of Southern California and is a professor of Communications at Mendocino College in Northern California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?799319f6